import { useEffect, useState } from "react";

const useMobileDetect = (initial?: boolean) => {
  const [isMobileOnly, setIsMobileOnly] = useState<boolean>(() => {
    if (typeof initial === "boolean") return initial;
    if (typeof window === "undefined") return false;
    const seeded = (window as any).__DEVICE__?.isMobile;
    if (typeof seeded === "boolean") return seeded;
    return window.innerWidth < 992;
  });

  useEffect(() => {
    if (typeof initial === "boolean") return;
    const onResize = () => setIsMobileOnly(window.innerWidth < 992);
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, [initial]);

  return isMobileOnly;
};

export default useMobileDetect;
